export const    CATEGORY = 'CATEGORY';
export const    CATEGORY_SUCCESS = 'CATEGORY_SUCCESS';
export const    CATEGORY_ERROR = 'CATEGORY_ERROR';

export const    ADD_CATEGORY = 'ADD_CATEGORY';
export const    ADD_CATEGORY_SUCCESS = 'ADD_CATEGORY_SUCCESS';
export const    ADD_CATEGORY_ERROR = 'ADD_CATEGORY_ERROR';

export const    UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const    UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS';
export const    UPDATE_CATEGORY_ERROR = 'UPDATE_CATEGORY_ERROR';

export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const DELETE_CATEGORY_SUCCESS= 'DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_ERROR ='DELETE_CATEGORY_ERROR';

export const CATEGORY_ICONS = 'CATEGORY_ICONS';
export const CATEGORY_ICONS_SUCCESS = 'CATEGORY_ICONS_SUCCESS';
export const CATEGORY_ICONS_ERROR = 'CATEGORY_ICONS_ERROR';

export const ICONS = 'ICONS';
export const ICONS_SUCCESS = 'ICONS_SUCCESS';
export const ICONS_ERROR = 'ICONS_ERROR';
